var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Block_18",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    width: 18,
    height: 18,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    fill: "none",
    stroke: "#a9a9a9",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_373",
    "data-name": "Rectangle 373",
    width: 8.75,
    height: 1.5,
    rx: 0.75,
    transform: "translate(4.625 8.156)",
    fill: "#a9a9a9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableBlockIcon);
export default __webpack_public_path__ + "static/media/DisableBlockIcon.37b755f622e7b8ea3345410d0768b11c.svg";
export { ForwardRef as ReactComponent };